import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@/design-system/atoms/Button';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Text } from '@/design-system/atoms/Text';
import { trackInteraction } from '@/utils/analytics';

import styles from './CategoryLinks.module.scss';

const CategoryLinks = ({ text, listItems }) => {
    const handleClickEvent = React.useCallback(
        (label) => {
            trackInteraction({
                componentName: 'category_links',
                componentTitle: text,
                interactionType: 'category_link',
                actionLabel: label,
                selector: 'button',
            });
        },
        [text],
    );
    return (
        <ContentContainer className={styles[`category-links`]}>
            {text && <Text content={text} tag={Text.TAG.P} variant={Text.VARIANT.T2} />}
            {Array.isArray(listItems) && listItems.length > 0 && (
                <div className={styles[`category-links__links-wrapper`]}>
                    {listItems?.map((category, index) => (
                        <Button
                            {...category}
                            buttonStyle={Button.STYLE.SECONDARY_SMALL}
                            key={index}
                            className={styles[`category-links__link`]}
                            onClick={() => handleClickEvent(category.label)}
                        />
                    ))}
                </div>
            )}
        </ContentContainer>
    );
};

CategoryLinks.propTypes = {
    /**
     * Array of category links
     */
    categories: PropTypes.arrayOf(Button.propTypes),
};

export default CategoryLinks;
